import { type UseQueryResult, useQuery } from 'react-query';
import { BlackoutSettlementTypeService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetBlackoutSettlementTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const blackoutSettlementTypes = useQuery(
    ['getBlackoutSettlementTypes'],
    async () => {
      return await handleRequest(
        BlackoutSettlementTypeService.getApiAwardApiAppBlackoutSettlementTypeNonMarketSettlementTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return blackoutSettlementTypes;
};

export default useGetBlackoutSettlementTypes;
